export const phoneCountryOptions = [
  { code: 'EG', dialCode: '+20', label: 'Egypt' },
  { code: 'SA', dialCode: '+966', label: 'Saudi Arabia' },
  { code: 'AE', dialCode: '+971', label: 'United Arab Emirates' },
  { code: 'QA', dialCode: '+974', label: 'Qatar' },
  { code: 'KW', dialCode: '+965', label: 'Kuwait' },
  { code: 'BH', dialCode: '+973', label: 'Bahrain' },
  { code: 'OM', dialCode: '+968', label: 'Oman' },
  { code: 'JO', dialCode: '+962', label: 'Jordan' },
  { code: 'LB', dialCode: '+961', label: 'Lebanon' },
  { code: 'MA', dialCode: '+212', label: 'Morocco' },
  { code: 'TR', dialCode: '+90', label: 'Turkey' },
  { code: 'GB', dialCode: '+44', label: 'United Kingdom' },
  { code: 'FR', dialCode: '+33', label: 'France' },
  { code: 'DE', dialCode: '+49', label: 'Germany' },
  { code: 'US', dialCode: '+1', label: 'United States' },
  { code: 'CA', dialCode: '+1', label: 'Canada' },
];

export function sanitizeLocalPhoneNumber(value) {
  return value.replace(/\D/g, '');
}

export function buildPhoneNumber(countryCode, localNumber) {
  const sanitizedLocalNumber = sanitizeLocalPhoneNumber(localNumber).replace(/^0+/, '');
  return `${countryCode}${sanitizedLocalNumber}`;
}

export function splitPhoneNumber(phoneNumber) {
  const normalizedPhoneNumber = String(phoneNumber ?? '').trim();

  if (!normalizedPhoneNumber) {
    return {
      countryCode: phoneCountryOptions[0]?.dialCode ?? '+20',
      phoneLocalNumber: '',
    };
  }

  const matchedOption = [...phoneCountryOptions]
    .sort((left, right) => right.dialCode.length - left.dialCode.length)
    .find((option) => normalizedPhoneNumber.startsWith(option.dialCode));

  if (matchedOption) {
    return {
      countryCode: matchedOption.dialCode,
      phoneLocalNumber: sanitizeLocalPhoneNumber(
        normalizedPhoneNumber.slice(matchedOption.dialCode.length)
      ),
    };
  }

  return {
    countryCode: phoneCountryOptions[0]?.dialCode ?? '+20',
    phoneLocalNumber: sanitizeLocalPhoneNumber(normalizedPhoneNumber),
  };
}
